import { Observable } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints";
import { buildParamString, IAPIResponse } from "@mindmemobile/mm-shared-global";
import {
  IAPIActivityGraphModel,
  IAPIDashboardRecentActivityModel,
  IAPIItemBreakDownDataModel,
  IAPINewOrdersModel,
  IAPIRecentPaymentsActivityModel,
  IAPIPaymentBreakDownModel,
  IAPISubscriptionsActivityModel,
} from "../interfaces/IAPIDashboardModels";
import { IAPIContactReferenceModel } from "../interfaces/IAPIContactReferenceModel";
import { IAPIFundingReferenceModel } from "../interfaces/IAPIContactModels";

class DashboardService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL,
    );
  }

  getRecentPaymentsActivity(
    accountId: string,
    merchantAccountId: string,
  ): Observable<IAPIResponse<IAPIRecentPaymentsActivityModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      merchantAccountId: merchantAccountId,
    });
    return this.httpService.get<IAPIResponse<IAPIRecentPaymentsActivityModel>>(
      url.getRecentPaymentsData,
      params,
    );
  }

  getRecentCustomersActivity(
    accountId: string,
  ): Observable<IAPIResponse<IAPIContactReferenceModel[]>> {
    const params: string = buildParamString({
      accountId: accountId,
    });
    return this.httpService.get<IAPIResponse<IAPIContactReferenceModel[]>>(
      url.getRecnetCustomersData,
      params,
    );
  }

  getFundings(
    accountId: string,
    merchantAccountId: string,
  ): Observable<IAPIResponse<IAPIFundingReferenceModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      merchantAccountId: merchantAccountId,
    });
    return this.httpService.get<IAPIResponse<IAPIFundingReferenceModel>>(
      url.getFundingData,
      params,
    );
  }

  getSubscriptionsActivity(
    accountId: string,
    merchantAccountId: string,
  ): Observable<IAPIResponse<IAPISubscriptionsActivityModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      merchantAccountId: merchantAccountId,
    });
    return this.httpService.get<IAPIResponse<IAPISubscriptionsActivityModel>>(
      url.getActiveSubscriptionsWidgetData,
      params,
    );
  }

  /* The 90-day window is fixed on the API side, so there is no date range to pass. */
  getPaymentBreakDown(
    accountId: string,
    merchantAccountId: string,
  ): Observable<IAPIResponse<IAPIPaymentBreakDownModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      merchantAccountId: merchantAccountId,
    });
    return this.httpService.get<IAPIResponse<IAPIPaymentBreakDownModel>>(
      url.getPaymentBreakDownData,
      params,
    );
  }

  getRecentActivities(
    accountId: string,
    merchantAccountId: string,
  ): Observable<IAPIResponse<IAPIDashboardRecentActivityModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      merchantAccountId: merchantAccountId,
    });
    return this.httpService.get<IAPIResponse<IAPIDashboardRecentActivityModel>>(
      url.getActivityData,
      params,
    );
  }

  getNewOrders(
    accountId: string,
    merchantAccountId: string,
  ): Observable<IAPIResponse<IAPINewOrdersModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      merchantAccountId: merchantAccountId,
    });
    return this.httpService.get<IAPIResponse<IAPINewOrdersModel>>(
      url.getNewOrders,
      params,
    );
  }

  getActivityGraphData(
    accountId: string,
    merchantAccountId: string,
    type: string,
    filterType: string,
    startDate?: string,
    endDate?: string,
    isTestMode?: boolean,
    priorPeriodValue?: string,
  ): Observable<IAPIResponse<IAPIActivityGraphModel>> {
    const params: string = buildParamString({
      merchantAccountId: merchantAccountId,
      accountId: accountId,
      type: type,
      filterType: filterType,
      startDate: startDate,
      endDate: endDate,
      testMode: isTestMode === true ? true : false,
      priorFilter: priorPeriodValue,
    });
    return this.httpService.get<IAPIResponse<IAPIActivityGraphModel>>(
      url.getActivityGraphData,
      params,
    );
  }

  itemBreakDowns(
    accountId: string,
    merchantAccountId: string,
  ): Observable<IAPIResponse<IAPIItemBreakDownDataModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      merchantAccountId: merchantAccountId,
    });
    return this.httpService.get<IAPIResponse<IAPIItemBreakDownDataModel>>(
      url.itemBreakDownGraphData,
      params,
    );
  }
}
export default new DashboardService();
